import { Route, Routes } from "react-router-dom";
import { Sidebar } from "./admin/Sidebar";
import { OverviewPage } from "./admin/OverviewPage";
import { BuilderPage } from "./admin/BuilderPage";
import { ProjectsPage } from "./admin/ProjectsPage";
import { ProjectDetailPage } from "./admin/ProjectDetailPage";
import { WebsitesPage } from "./admin/WebsitesPage";
import { LeadsPage } from "./admin/LeadsPage";
import { ZipLookupPage } from "./admin/ZipLookupPage";
import { LogoGeneratorPage } from "./admin/LogoGeneratorPage";
import { SettingsPage } from "./admin/SettingsPage";
import { AffiliateSitesPage } from "./admin/affiliate/AffiliateSitesPage";
import { AffiliateBuilderPage } from "./admin/affiliate/AffiliateBuilderPage";
import { AffiliateSiteDetailPage } from "./admin/affiliate/AffiliateSiteDetailPage";
import { AffiliateToolsLibraryPage } from "./admin/affiliate/AffiliateToolsLibraryPage";
import { CommercialDashboard } from "./admin/commercial/CommercialDashboard";
import { GeoDashboard } from "./admin/geo/GeoDashboard";
import { ReputationDashboard } from "./admin/reputation/ReputationDashboard";
import { ReputationLeadsPage } from "./admin/reputation/ReputationLeadsPage";
import { ReputationAIPage } from "./admin/reputation/ReputationAIPage";
import { ReputationPublishPage } from "./admin/reputation/ReputationPublishPage";

export default function AdminDashboard({ user, onLogout }) {
  return (
    <div className="flex min-h-screen bg-slate-100" data-testid="admin-dashboard">
      <Sidebar onLogout={onLogout} />
      <main className="flex-1 p-8 overflow-auto">
        <Routes>
          <Route index element={<OverviewPage />} />
          <Route path="builder" element={<BuilderPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="projects/:id" element={<ProjectDetailPage />} />
          <Route path="websites" element={<WebsitesPage />} />
          <Route path="leads" element={<LeadsPage />} />
          <Route path="zip-lookup" element={<ZipLookupPage />} />
          <Route path="logo-generator" element={<LogoGeneratorPage />} />
          <Route path="settings" element={<SettingsPage />} />
          {/* Affiliate Hub */}
          <Route path="affiliate" element={<AffiliateSitesPage />} />
          <Route path="affiliate/sites" element={<AffiliateSitesPage />} />
          <Route path="affiliate/builder" element={<AffiliateBuilderPage />} />
          <Route path="affiliate/sites/:siteId" element={<AffiliateSiteDetailPage />} />
          <Route path="affiliate/tools" element={<AffiliateToolsLibraryPage />} />
          {/* Commercial Network (A-Star) */}
          <Route path="commercial" element={<CommercialDashboard />} />
          {/* GEO Restoration (A-Star Restoration) */}
          <Route path="geo" element={<GeoDashboard />} />
          {/* Reputation Recovery (FakeReviewRemovalPro.com) */}
          <Route path="reputation" element={<ReputationDashboard />} />
          <Route path="reputation/leads" element={<ReputationLeadsPage />} />
          <Route path="reputation/ai" element={<ReputationAIPage />} />
          <Route path="reputation/publish" element={<ReputationPublishPage />} />
        </Routes>
      </main>
    </div>
  );
}
